export const getValueFromEventTarget = (event: React.ChangeEvent<HTMLInputElement>) => event.target.value;